/**
 * Basic Eligibility
 * this helper validate the user income and
 * work area.
 * The work area should be at the ELIGIBLE_AREAS
 * and the sum of variable and fixed income
 * should be greater than MIN_TOTAL_INCOME.
 */
import store from '@/store';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import {
    MIN_TOTAL_INCOME,
    MIN_FIXED_INCOME_DSP,
    END_PAGE_OPS,
    NOT_ELIGIBLE,
    CREDIT_NOT_APPROVED_TITLE,
    NOT_ELIGIBLE_MESSAGE,
    BASIC_NOT_ELIGIBLE,
    END_FORM,
    MIN_ALLOWED_DBR,
    DBR_CARD_LIMIT_PERCENT,
    MIN_TOTAL_INCOME_LOAN
} from '@/forms/constants/onboarding-logic';

const ELIGIBLE_AREAS_CARD = [
    'DUBAI',
    'SHARJAH',
    'ABU DHABI',
    'AJMAN',
];

const ELIGIBLE_AREAS_LOAN = [
    'DUBAI',
    'SHARJAH',
    'ABU DHABI',
    'AJMAN',

];
const ELIGIBLE_MEDIUM_OF_RECEIVE = [
    'CASH',
    'CHEQUE',
];
const NOT_ELIGIBLE_COMPANY_AGE = [

    '0-5 MONTHS',
    '6-11 MONTHS',
];
var path = window.location.href;
// eslint-disable-next-line arrow-body-style
const calculateDBR = (installments, cardLimit, fixedIncome) => {
    return (installments + (DBR_CARD_LIMIT_PERCENT * cardLimit)) / fixedIncome * 100;
};

const getFailedCondition = (callback, reasonToStay) => ({
    moveToNextStep: false,
    reasonToStay,
    stopForm: true,
    onFail: () => callback(reasonToStay, END_PAGE_OPS),
});

export default (logicCallback, $store) => {
    let _store = $store;
    if (!_store.state) {
        _store = store;
    }

    const { state: { productTypeFromUrl, productType, appianPersonalInfo, employeeCodes, formData: { values } } } = _store;
    const { onConditionFailedCallback } = logicCallback;

    const fixed = getValueByFieldName(values, FIELD_NAMES.fixedIncome);
    const areaOfWork = getValueByFieldName(values, FIELD_NAMES.areaOfWork);
    const mediumOfReceive = getValueByFieldName(values, FIELD_NAMES.mediumOfReceive);
    const installmentAmount = getValueByFieldName(values, FIELD_NAMES.haveLoan) || 0;
    const cardLimit = getValueByFieldName(values, FIELD_NAMES.haveCreditCard) || 0;
    const variable = getValueByFieldName(values, FIELD_NAMES.variableIncome);
    const dob = getValueByFieldName(values, FIELD_NAMES.birthDate);
    const tenure = getValueByFieldName(values, FIELD_NAMES.instalmentsAmount);
    const livingTime = getValueByFieldName(values, FIELD_NAMES.livingTime);
    const workExperience = getValueByFieldName(values, FIELD_NAMES.workAmount);
    const companyAge = getValueByFieldName(values, FIELD_NAMES.companyAge);
    const employmentType = getValueByFieldName(values, FIELD_NAMES.employmentType)
    let acceptedIncome;
    let acceptedCompnayAge;
    if (employeeCodes) {
        if (productType === 'Credit Card') {
            if (fixed >= MIN_FIXED_INCOME_DSP) {
                acceptedIncome = (fixed + variable) >= MIN_TOTAL_INCOME;
            } else if (fixed < MIN_FIXED_INCOME_DSP) {
                acceptedIncome = false;
            }
        } else if (productType === 'Personal_Loan') {
            acceptedIncome = fixed >= MIN_TOTAL_INCOME_LOAN; //&& livingTime === '240+ Months';
        }

    } else {
        if (productType === 'Credit Card') {
            acceptedIncome = fixed >= MIN_TOTAL_INCOME;
        } else if (productType === 'Personal_Loan') {
            acceptedIncome = fixed >= MIN_TOTAL_INCOME_LOAN; //&& livingTime === '240+ Months';
        }

    }
    const acceptedMediumOfReceive = ELIGIBLE_MEDIUM_OF_RECEIVE.indexOf(mediumOfReceive.toUpperCase()) !== -1
    var acceptedArea = '';

    if (productType === 'Personal_Loan') {
        acceptedArea = ELIGIBLE_AREAS_LOAN.indexOf(areaOfWork.toUpperCase()) !== -1;
    } else if (productType === 'Credit Card') {
        acceptedArea = ELIGIBLE_AREAS_CARD.indexOf(areaOfWork.toUpperCase()) !== -1;
    }
    if (employmentType) {

        if (employmentType === 'Salaried') {
            acceptedCompnayAge = NOT_ELIGIBLE_COMPANY_AGE.indexOf(workExperience.toUpperCase()) !== -1;
        }
        if (employmentType === 'Self-employed') {

            acceptedCompnayAge = NOT_ELIGIBLE_COMPANY_AGE.indexOf(companyAge.toUpperCase()) !== -1


        }
    }
    const acceptedDBR = calculateDBR(installmentAmount, cardLimit, fixed) < MIN_ALLOWED_DBR;

    // if (!acceptedIncome || !acceptedArea || !acceptedDBR) {
    //   return getFailedCondition(onConditionFailedCallback, {
    //     title: CREDIT_NOT_APPROVED_TITLE(values.firstName),
    //     subtitle: NOT_ELIGIBLE_MESSAGE,
    //     name: NOT_ELIGIBLE,
    //     actions: [
    //       { click: END_FORM, label: 'Continue' },
    //     ],
    //   });
    // }
    if (appianPersonalInfo && !employmentType) {
        if (appianPersonalInfo.toUpperCase() === 'FAILURE') {
            return getFailedCondition(onConditionFailedCallback, {
                title: CREDIT_NOT_APPROVED_TITLE(values.firstName),
                subtitle: NOT_ELIGIBLE_MESSAGE,
                name: NOT_ELIGIBLE,
                actions: [
                    { click: END_FORM, label: 'Continue' },
                ],
            });
        }
    }
    // else if(workExperience)
    // {
    //   console.log('inside workexpreeince')
    //   if (!acceptedIncome  ) {
    //     return getFailedCondition(onConditionFailedCallback, {
    //       title: CREDIT_NOT_APPROVED_TITLE(values.firstName),
    //       subtitle: NOT_ELIGIBLE_MESSAGE,
    //       name: NOT_ELIGIBLE,
    //       actions: [
    //         { click: END_FORM, label: 'Continue' },
    //       ],
    //     });
    //   }
    // }
    else {
        if (!acceptedIncome || !acceptedArea || acceptedMediumOfReceive || acceptedCompnayAge) {
            return getFailedCondition(onConditionFailedCallback, {
                title: CREDIT_NOT_APPROVED_TITLE(values.firstName),
                subtitle: NOT_ELIGIBLE_MESSAGE,
                name: NOT_ELIGIBLE,
                actions: [
                    { click: END_FORM, label: 'Continue' },
                ],
            });
        }
    }

    return {
        moveToNextStep: true,
    };
};